import React from 'react';
import { PropTypes } from 'prop-types';
import { withStyles } from '@mui/styles';
import { withRouter } from 'utils';
import { Typography, Tabs, Tab } from '@mui/material';

const styles = (theme) => ({
  container: {
    backgroundColor: theme.palette.primary.accent,
  },
  header: {
    padding: theme.spacing(3),
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  headerTitle: {
    color: '#FFFFFF',
    fontSize: 24,
    paddingRight: 30,
  },
  tabs: {
    paddingTop: 3,
    paddingLeft: theme.spacing(3),
    backgroundColor: theme.palette.primary.accent,
  },
  indicator: {
    backgroundColor: '#FFFFFF',
    height: 2,
    marginBottom: 8,
  },
  tabPanel: {
    color: '#E0E0E0',
    '&.Mui-selected': {
      color: '#FFFFFF',
    },
    '&:hover': {
      color: '#FFFFFF',
    },
  },
});

class VisitsTabs extends React.Component {
  render() {
    const {
      tab,
      classes,
    } = this.props;

    return (
      <div className={classes.container}>
        <title>Visits &amp; Referrals</title>
        <div className={classes.header}>
          <Typography className={classes.headerTitle}>
            Visits &amp; Referrals
          </Typography>
        </div>
        <Tabs
          variant='scrollable'
          className={classes.tabs}
          TabIndicatorProps={{ className: classes.indicator }}
          value={tab}
          onChange={this.onTabChange}
        >
          <Tab
            className={classes.tabPanel}
            label='Departments'
            value='visits'
            disableRipple
          />
          <Tab
            className={classes.tabPanel}
            label='Flow'
            value='flow'
            disableRipple
          />
        </Tabs>
      </div>
    );
  }

  onTabChange = (event, newValue) => {
    this.props.router.navigate(`/${newValue}/`);
  };
}

VisitsTabs.propTypes = {
  router: PropTypes.object.isRequired,
  classes: PropTypes.object,
  tab: PropTypes.string.isRequired,
};

const styled = withStyles(styles)(VisitsTabs);
const routed = withRouter(styled);
export { routed as VisitsTabs };
